import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        api_token: localStorage.getItem('api_token') || undefined,
        isdeveloper: false,
        isauth: false,
        user: null,

    },
    getters: {
        TOKEN: state => {
            return state.api_token;
        },
        ISDEVELOPER: state => {
            return state.isdeveloper;
        },
        ISAUTH: state => {
            return state.isauth;
        },
        USER: state => {
            return state.user;
        }
    },

    mutations: {

        SET_TOKEN: (state, payload) => {

            state.api_token = payload;
        },
        SET_ISDEVELOPER: (state, payload) => {
            state.isdeveloper = payload;
        },
        SET_ISAUTH: (state, payload) => {
            state.isauth = payload;
        },
        SET_USER: (state, payload) => {
            state.user = payload;
        },
        INITIALISATION_STORE(state) {
            if(localStorage.getItem('token')){
                state.api_token = localStorage.getItem('api_token');
            }
            if(localStorage.getItem('user')) {
                state.user = JSON.parse(localStorage.getItem('user'))
            }
        }
    }
})